<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Sedi </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="dialog_calendario_generico = true"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-calendar </v-icon>
          </v-btn>
        </template>
        <span>Vedi calendario generico</span>
      </v-tooltip>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-data-table
      height="60vh"
      style="width: 40vw; margin: auto"
      :headers="headers_sedi"
      :items="lista_sedi"
      fixed-header
      :key="aggiorna"
      class="elevation-1 pt-0"
    >
      <!-- Colonna del calendario specifico -->
      <template v-slot:[`item.cal_spec`]="{ item }">
        <v-btn
          @click="
            dialog_calendario_specifico = true;
            sede_sel_id = item.id_azienda_sede;
          "
          small
          ><v-icon :color="item.eccezione ? 'orange' : 'primary'"
            >mdi-calendar-star</v-icon
          ></v-btn
        >
      </template>
    </v-data-table>
    <!-- DIALOG CALENDARIO GENERICO -->
    <v-dialog v-model="dialog_calendario_generico" max-width="600px">
      <CalendarioGenerico
        @click_chiudi="dialog_calendario_generico = false"
        :bottoni="true"
      />
    </v-dialog>
    <!-- DIALOG CALENDARIO SPECIFICO -->
    <v-dialog v-model="dialog_calendario_specifico" max-width="800px">
      <CalendarioSpecifico
        @click_chiudi="
          dialog_calendario_specifico = false;
          getEccezioniLista();
        "
        :id_riferimento="sede_sel_id"
        :tipo="1"
        :visibilita="dialog_calendario_specifico"
      />
    </v-dialog>
    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import CalendarioGenerico from "@/components/PRODUCTION/Impostazioni/Calendario/CalendarioGenerico.vue";
import CalendarioSpecifico from "@/components/PRODUCTION/Impostazioni/Calendario/CalendarioSpecifico.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "",

  components: { SnackbarQV, CalendarioGenerico, CalendarioSpecifico },

  props: ['id_azienda_sede'],

  data() {
    return {
      // Variabili d'appoggio
      sede_sel_id: null,
      aggiorna: 0,
      // Modal
      dialog_calendario_generico: false,
      dialog_calendario_specifico: false,

      // Array
      headers_sedi: new Array(),
      lista_sedi: new Array(),
      lista_eccezioni: new Array(),
    };
  },

  computed: {},

  watch: {},

  methods: {
    getSedi() {
      this.headers_sedi = [
        {
          text: "Calendario specifico",
          value: "cal_spec",
        },
        {
          text: "Nome",
          value: "descrizione",
        },
      ];

      let request = {
        controller: "schedulatore",
        method: "POST",
        richiesta: {
          token:  localStorage.getItem("user_token"),
          action: "getaziendasedi",
          id_azienda: 1,
          id_azienda_sede: this.id_azienda_sede,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.lista_sedi = res.data.result ? res.data.result : [];
            this.getEccezioniLista();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },

    getEccezioniLista() {
      let request = {
        controller: "Tools",
        method: "POST",
        richiesta: {
          action: "geteccezionilista",
          token: localStorage.getItem("user_token"),
          tipo: 1,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.lista_eccezioni = res.data.calendario_ecc
              ? res.data.calendario_ecc
              : [];
            this.lista_sedi.forEach((sede) => {
              sede.eccezione = false;
              this.lista_eccezioni.forEach((ecc) => {
                if (sede.id_azienda_sede == ecc.rif_calendario) {
                  sede.eccezione = true;
                }
              });
            });

            this.aggiorna = this.aggiorna == 1 ? 0 : 1;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
  },

  created() {},

  mounted() {
    this.getSedi();
  },
};
</script>

<style scoped>
</style>